import { skipAbortError } from '@app/errors/AbortError'

import { sleep } from '@app/utils/sleep'

import classes from './highlightElement.module.scss'

export async function highlightElement({
  element,
  zIndex = 9999,
  duration = 2000,
  padding = 0,
  abortSignal,
}: {
  element: Element
  zIndex?: number
  duration?: number
  padding?: number | [number, number]
  abortSignal?: AbortSignal
}) {
  if (elements.has(element)) return
  elements.add(element)
  let interval: ReturnType<typeof setInterval> | null = null

  try {
    const overlay = document.createElement('div')
    overlay.classList.add(classes.overlay)
    overlay.style.zIndex = String(zIndex)
    overlay.style.pointerEvents = 'none'
    overlay.style.height = document.documentElement.scrollHeight + 'px'

    const el = document.createElement('div')
    el.classList.add(classes.root)
    el.classList.add(classes.transition)
    el.style.zIndex = String(zIndex)

    interval = setInterval(() => {
      const box = element.getBoundingClientRect()
      const paddingV = Array.isArray(padding) ? padding[0] : padding
      const paddingH = Array.isArray(padding) ? padding[1] : padding

      el.style.width = `${box.width + paddingH * 2}px`
      el.style.height = `${box.height + paddingV * 2}px`

      el.style.left = `${window.scrollX + box.left - paddingH}px`
      el.style.top = `${window.scrollY + box.top - paddingV}px`
    }, 10)

    overlay.appendChild(el)
    document.body.appendChild(overlay)
    await sleep(200)
    el.classList.remove(classes.transition)

    const res = await sleep(duration, abortSignal)
      .then(() => true)
      .catch(skipAbortError)
    if (!res) return
    el.classList.add(classes.transition)
    await sleep(200)
    document.body.removeChild(overlay)
  } finally {
    if (interval) clearInterval(interval)
    elements.delete(element)
  }
}

const elements = new Set<Element>()
